import { all, fork, call, put, takeEvery, take, cancel } from 'redux-saga/effects';
import {
  deleteEntity,
  loadEntities,
  updateEntity,
  fetchResource,
  showErrorMessage,
  LOGOUT_ACTION_TYPES,
} from 'helpers/utilHelpers';
import {
  DELETE_TASK,
  LOAD_TASK_BY_ID,
  LOAD_TASK_LABELS,
  LOAD_TASK_STATUSES,
  LOAD_TASKS,
  UPDATE_TASK,
  LOAD_DEFAULT_REPORT,
  LOAD_DETAIL_REPORT,
  LOAD_USER_REPORT,
  LOAD_TASK_LABEL_GROUPS,
  LOAD_WORKFLOWS,
  UPDATE_TASK_LABEL,
  UPDATE_TASK_STATUS,
  DELETE_TASK_LABEL,
  DELETE_TASK_STATUS,
  UPDATE_TASK_LABEL_GROUP,
  UPDATE_WORKFLOW,
  DELETE_TASK_LABEL_GROUP,
  DELETE_WORKFLOW,
  TASK_SEND_EMOJI,
  LOAD_TASK_MIGRATE_INFO,
  TASK_MIGRATE,
  // Checklist actions
  UPDATE_CHECKLIST,
  DELETE_CHECKLIST,
  UPDATE_CHECKLIST_ITEM,
  DELETE_CHECKLIST_ITEM,
  CHECK_CHECKLIST_ITEM,
  TASK_VIEW_COMMENT_NOTIFICATIONS,
  LOAD_BOARD_TASKS,
  UPDATE_TASKS,
  DRAG_CHECKLIST_ITEM,
  // Task template actions
  LOAD_TASK_TEMPLATE_CONSTANTS,
  APPLY_TASK_TEMPLATE,
  LOAD_TASK_TEMPLATES,
  LOAD_TASK_TEMPLATE,
  UPDATE_TASK_TEMPLATE,
  DELETE_TASK_TEMPLATE,
  EXPORT_REPORT,
  // Task schedule actions
  LOAD_TASK_SCHEDULE,
  UPDATE_TASK_SCHEDULE,
  DELETE_TASK_SCHEDULE,
  SUBSCRIBE_TASK_CHANGES,
  UNSUBSCRIBE_TASK_CHANGES,
  APPEND_ACTIVITY_LOG,
  CHANGE_STATUS_POSITION,
  LOAD_TASK_STATUSES_COUNTERS,
  UPDATE_TASK_ORDER,
} from 'constants/ActionTypes';
import SocketService from 'services/SocketService';
import { SOCKET } from 'constants/SocketConstants';

const socketInstance = SocketService.Instance;

function* loadTask() {
  yield takeEvery(LOAD_TASKS, loadEntities);
}

function* loadBoardTasks() {
  yield takeEvery(LOAD_BOARD_TASKS, loadEntities);
}

function* loadTaskLabels() {
  yield takeEvery(LOAD_TASK_LABELS, loadEntities);
}

function* loadTaskStatuses() {
  yield takeEvery(LOAD_TASK_STATUSES, loadEntities);
}

function* updateTask() {
  yield takeEvery(UPDATE_TASK, updateEntity);
}

function* updateTaskOrder() {
  yield takeEvery(UPDATE_TASK_ORDER, updateEntity);
}

function* batchUpdateTasks() {
  yield takeEvery(UPDATE_TASKS, updateEntity);
}

function* viewTaskCommentNotifications() {
  yield takeEvery(TASK_VIEW_COMMENT_NOTIFICATIONS, updateEntity);
}

function* taskSendEmoji() {
  yield takeEvery(TASK_SEND_EMOJI, fetchTaskSendEmoji);
}

function* fetchTaskSendEmoji(action) {
  try {
    const response = yield call(() => fetchResource('tasks/' + action.payload.taskId + '/react', 'PUT', action.values));
    yield put(action.payload.onSuccess(response));
  } catch (e) {
    yield showErrorMessage(action.payload.onErrorMessage);
  }
}

function* deleteTask() {
  yield takeEvery(DELETE_TASK, deleteEntity);
}

function* loadTaskById() {
  yield takeEvery(LOAD_TASK_BY_ID, loadEntities);
}

function* loadDefaultReport() {
  yield takeEvery(LOAD_DEFAULT_REPORT, loadEntities);
}

function* exportReport() {
  yield takeEvery(EXPORT_REPORT, loadEntities);
}

function* loadDetailReport() {
  yield takeEvery(LOAD_DETAIL_REPORT, loadEntities);
}

function* loadUserReport() {
  yield takeEvery(LOAD_USER_REPORT, loadEntities);
}

function* loadTaskLabelGroups() {
  yield takeEvery(LOAD_TASK_LABEL_GROUPS, loadEntities);
}

function* loadWorkflows() {
  yield takeEvery(LOAD_WORKFLOWS, loadEntities);
}

function* updateTaskLabel() {
  yield takeEvery(UPDATE_TASK_LABEL, updateEntity);
}

function* updateTaskStatus() {
  yield takeEvery(UPDATE_TASK_STATUS, updateEntity);
}

function* changeStatusPosition() {
  yield takeEvery(CHANGE_STATUS_POSITION, updateEntity);
}

function* loadTaskStatusesCounters() {
  yield takeEvery(LOAD_TASK_STATUSES_COUNTERS, loadEntities);
}

function* deleteTaskLabel() {
  yield takeEvery(DELETE_TASK_LABEL, deleteEntity);
}

function* deleteTaskStatus() {
  yield takeEvery(DELETE_TASK_STATUS, deleteEntity);
}

function* updateTaskLabelGroup() {
  yield takeEvery(UPDATE_TASK_LABEL_GROUP, updateEntity);
}

function* updateWorkflow() {
  yield takeEvery(UPDATE_WORKFLOW, updateEntity);
}

function* deleteTaskLabelGroup() {
  yield takeEvery(DELETE_TASK_LABEL_GROUP, deleteEntity);
}

function* deleteWorkflow() {
  yield takeEvery(DELETE_WORKFLOW, deleteEntity);
}

function* loadTaskMigrateInfo() {
  yield takeEvery(LOAD_TASK_MIGRATE_INFO, loadEntities);
}

function* taskMigrate() {
  yield takeEvery(TASK_MIGRATE, updateEntity);
}

// Checklist actions

function* updateChecklist() {
  yield takeEvery(UPDATE_CHECKLIST, updateEntity);
}

function* deleteChecklist() {
  yield takeEvery(DELETE_CHECKLIST, deleteEntity);
}

function* updateChecklistItem() {
  yield takeEvery(UPDATE_CHECKLIST_ITEM, updateEntity);
}

function* dragChecklistItem() {
  yield takeEvery(DRAG_CHECKLIST_ITEM, updateEntity);
}

function* deleteChecklistItem() {
  yield takeEvery(DELETE_CHECKLIST_ITEM, deleteEntity);
}

function* checkChecklistItem() {
  yield takeEvery(CHECK_CHECKLIST_ITEM, updateEntity);
}

// Task template sagas
function* loadTaskTemplateConstants() {
  yield takeEvery(LOAD_TASK_TEMPLATE_CONSTANTS, loadEntities);
}

function* loadTaskTemplates() {
  yield takeEvery(LOAD_TASK_TEMPLATES, loadEntities);
}

function* loadTaskTemplateById() {
  yield takeEvery(LOAD_TASK_TEMPLATE, loadEntities);
}

function* updateTaskTemplate() {
  yield takeEvery(UPDATE_TASK_TEMPLATE, updateEntity);
}

function* deleteTaskTemplate() {
  yield takeEvery(DELETE_TASK_TEMPLATE, deleteEntity);
}

function* applyTaskTemplate() {
  yield takeEvery(APPLY_TASK_TEMPLATE, loadEntities);
}

function* loadTaskSchedule() {
  yield takeEvery(LOAD_TASK_SCHEDULE, loadEntities);
}

function* updateTaskSchedule() {
  yield takeEvery(UPDATE_TASK_SCHEDULE, updateEntity);
}

function* deleteTaskSchedule() {
  yield takeEvery(DELETE_TASK_SCHEDULE, deleteEntity);
}

function* subscribeTaskChanges() {
  while (true) {
    yield take(SUBSCRIBE_TASK_CHANGES);
    const channel = yield call(socketInstance.onSubscribe, SOCKET.taskChanges);
    const task = yield takeEvery(channel, function*(data) {
      yield put({
        type: APPEND_ACTIVITY_LOG,
        payload: data,
      });
    });

    yield take([...LOGOUT_ACTION_TYPES, UNSUBSCRIBE_TASK_CHANGES]);

    channel.close();
    yield cancel(task);
  }
}

export default function* rootSaga() {
  yield all([
    fork(loadDefaultReport),
    fork(loadDetailReport),
    fork(loadTaskById),
    fork(deleteTask),
    fork(loadTask),
    fork(updateTask),
    fork(updateTaskOrder),
    fork(loadBoardTasks),
    fork(loadTaskLabels),
    fork(loadTaskStatuses),
    fork(loadTaskStatusesCounters),
    fork(loadUserReport),
    fork(loadTaskLabelGroups),
    fork(loadWorkflows),
    fork(updateTaskLabel),
    fork(updateTaskStatus),
    fork(changeStatusPosition),
    fork(deleteTaskLabel),
    fork(deleteTaskStatus),
    fork(updateTaskLabelGroup),
    fork(updateWorkflow),
    fork(deleteTaskLabelGroup),
    fork(deleteWorkflow),
    fork(taskSendEmoji),
    fork(updateChecklist),
    fork(deleteChecklist),
    fork(updateChecklistItem),
    fork(deleteChecklistItem),
    fork(checkChecklistItem),
    fork(viewTaskCommentNotifications),
    fork(loadTaskMigrateInfo),
    fork(taskMigrate),
    fork(batchUpdateTasks),
    fork(dragChecklistItem),
    fork(subscribeTaskChanges),
    // Task template forks
    fork(loadTaskTemplateConstants),
    fork(loadTaskTemplates),
    fork(loadTaskTemplateById),
    fork(updateTaskTemplate),
    fork(deleteTaskTemplate),
    fork(applyTaskTemplate),
    fork(exportReport),
    // Task schedule forks
    fork(updateTaskSchedule),
    fork(loadTaskSchedule),
    fork(deleteTaskSchedule),
  ]);
}
